/** Locale-aware integer formatting (12 345). */
export const formatNumber = (value) =>
  Number.isFinite(Number(value)) && value !== ""
    ? new Intl.NumberFormat().format(Number(value))
    : value;

/** Evolution in % from `previous` to `current` (one decimal), `null` when not comparable. */
export const changeOf = (current, previous) =>
  Number.isFinite(current) && Number.isFinite(previous) && previous > 0
    ? Math.round(((current - previous) / previous) * 1000) / 10
    : null;

/** Signed evolution in % ("+12,5 %", "−3 %"), `null` when unknown. */
export const formatChange = (change) => {
  if (!Number.isFinite(change)) return null;
  const formatted = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
    signDisplay: "exceptZero",
  }).format(change);
  return `${formatted} %`;
};

/** Rounded share of `value` in `total`, 0 when total is empty. */
export const percent = (value, total) =>
  total > 0 ? Math.round((value / total) * 100) : 0;
